import { boot } from 'quasar/wrappers'

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async (/* { app, router, ... } */) => {
  // something to do

})


// required
//
// SELF-HOSTED, SUBSETTED FontAwesome Pro (see scripts/subset-fontawesome.py).
// We import a committed copy under src/assets/fontawesome/ whose webfonts contain
// ONLY the icons this app can render. That set = (frontend source icons) UNION
// (admin-configured menu icons from the DB). The DB icons are FREE-TEXT and live
// in settings.qbank_sidebar_items + products.settings, so they are listed in
// scripts/fa-extra-icons.txt and folded into the subset.
//
// This cut the FA font payload from ~1.34 MB (4 full weights) to ~41 KB.
//
// (!) WHEN AN ADMIN ADDS A NEW MENU ICON: add it to scripts/fa-extra-icons.txt
// (or re-dump from the DB — see the script header), re-run the script, and commit
// the regenerated src/assets/fontawesome/ artifacts. Otherwise the new icon
// renders as a tofu box. Do NOT switch these imports back to
// '@fortawesome/fontawesome-pro/css/*': `npm ci` on deploy restores the FULL
// fonts and re-bloats every cold load.

import '../assets/fontawesome/css/fontawesome.css'
import '../assets/fontawesome/css/thin.css'
import '../assets/fontawesome/css/solid.css'
import '../assets/fontawesome/css/regular.css'
import '../assets/fontawesome/css/light.css'

// `brands` + `duotone` are intentionally not shipped (never used).

// SELF-HOSTED, SUBSETTED Material Icons (replaces Quasar's `extras:
// ["material-icons"]`, which shipped the full ~126 KB font). This is the ~15 KB
// subset of icons the app + Quasar components actually render. The material-icons
// ICONSET (q-icon name→ligature mapping) is unchanged — only the font delivery.
// Regenerate via scripts/subset-material-icons.py when adding DB/config icons.
import '../assets/material-icons/material-icons.css'
